import { useState } from "react";

import { Anchor } from "@atlassiansox/bxp-content-framework";

import { LinkButton } from "../..";
import { paidProductCodes } from "../../client";
import { useAnalytics, useMember } from "../../components";
import { UiWorkspacePickerModel } from "../../models";

import {
    Dropdown,
    DropdownWorkspace,
    DropdownButton,
    BottomArrow
} from "./UiWorkspacePicker.styles";

export type UiWorkspacePickerProps = {
    readonly model: UiWorkspacePickerModel;
};

// eslint-disable-next-line complexity -- TODO: refactor to reduce complexity
const UiWorkspacePicker = ({ model }: UiWorkspacePickerProps) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const { sendTrackEvent } = useAnalytics();
    const member = useMember();

    const {
        dropdownTitle,
        noCreditsLeft,
        noEligibleAdmin,
        noWorkspace,
        noWorkspaceUrl,
        invalidLoginToken,
        urlAppendix
    } = model.content;

    switch (member.status) {
        case "pending":
            return null;
        case "rejected":
            return (
                <Dropdown>
                    <LinkButton
                        appearance="Light"
                        url={`/login?returnURL=${urlAppendix}`}
                        decorator={"Arrow"}
                    >
                        {invalidLoginToken}
                    </LinkButton>
                </Dropdown>
            );
        case "resolved":
            const { organizations = [], id, credits = [] } = member.value;

            const eligibleOrganizations = organizations.filter(
                (organization) => {
                    const orgHasPaidProducts = organization.products
                        ? organization.products.filter(function (product) {
                              return paidProductCodes.includes(product);
                          }).length > 0
                        : false;

                    const userIsAdmin = organization.memberships
                        ? organization.memberships.filter((membership) => {
                              return (
                                  membership.idMember == id &&
                                  membership.memberType == "admin"
                              );
                          }).length > 0
                        : false;

                    return userIsAdmin && !orgHasPaidProducts;
                }
            );

            if (organizations.length === 0 && credits.length === 0) {
                return (
                    <Dropdown>
                        <LinkButton
                            appearance="Light"
                            url={noWorkspaceUrl}
                            decorator={"Arrow"}
                        >
                            {noWorkspace}
                        </LinkButton>
                    </Dropdown>
                );
            } else {
                return (
                    <Dropdown data-testid="dropdown">
                        <DropdownButton
                            onClick={() => setDropdownOpen(!dropdownOpen)}
                            data-testid="dropdown-button"
                        >
                            <BottomArrow>{dropdownTitle}</BottomArrow>
                        </DropdownButton>

                        {dropdownOpen &&
                            eligibleOrganizations.length === 0 &&
                            credits.length === 0 && (
                                <DropdownWorkspace>
                                    <span data-testid="no-admins">
                                        {noEligibleAdmin}
                                    </span>
                                </DropdownWorkspace>
                            )}

                        {dropdownOpen &&
                            eligibleOrganizations.length > 0 &&
                            credits.length === 0 && (
                                <DropdownWorkspace>
                                    {eligibleOrganizations.map((workspace) => (
                                        <Anchor
                                            href={`${workspace.url}${urlAppendix}`}
                                            onClick={() =>
                                                sendTrackEvent(
                                                    "clickedUiWorkspacePicker",
                                                    {
                                                        event: "clicked",
                                                        eventComponent:
                                                            model.type,
                                                        eventContainer:
                                                            "content",
                                                        label: workspace.displayName,
                                                        labelEnglish:
                                                            workspace.displayName,
                                                        uuid: id,
                                                        href: `${workspace.url}${urlAppendix}`
                                                    }
                                                )
                                            }
                                            data-uuid={id}
                                            key={workspace.name}
                                            testId="workspace-link"
                                        >
                                            {workspace.displayName}
                                        </Anchor>
                                    ))}
                                </DropdownWorkspace>
                            )}

                        {
                            // if a member has credits, they aren't eligible for free trial
                            dropdownOpen && credits.length > 0 && (
                                <DropdownWorkspace>
                                    <span data-testid="no-credits">
                                        {noCreditsLeft}
                                    </span>
                                </DropdownWorkspace>
                            )
                        }
                    </Dropdown>
                );
            }
    }
};

export default UiWorkspacePicker;
